$(function() {
  $('body').on('click', '.alert', function() {
    $(this).remove()
  })
})
